export default __webpack_public_path__ + "static/media/Killjoy_artwork.1cbf19e4.png";